import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { OrientationLockComponent } from "./orientation-lock/orientation-lock.component";
import { LemIconComponent } from "./lem-icon/lem-icon.component";
import { HighlightComponent } from "./highlight/highlight.component";
import { ArrowsComponent } from "./arrows/arrows.component";
import { LanguageModule } from 'src/app/language/language.module';

// import { InstructionComponent } from "./instruction/instruction.component";

@NgModule({
    declarations: [
        OrientationLockComponent,
        LemIconComponent,
        HighlightComponent,
        ArrowsComponent,
        // InstructionComponent,
    ],
    imports: [
        CommonModule,
        IonicModule,
    ],
    exports: [
        OrientationLockComponent,
        LemIconComponent,
        HighlightComponent,
        ArrowsComponent,
        // InstructionComponent,
    ],
})
export class ComponentsModule { }
